import { Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';

@Component({
  selector: 'app-skeleton-detail',
  templateUrl: './skeleton-detail.component.html',
  styleUrls: ['./skeleton-detail.component.scss']
})
export class SkeletonDetailComponent implements OnInit {

  constructor(private _location: Location) { }

  ngOnInit() {
  }

  backClicked() {
    this._location.back();
  }

}
